import { TrialPromoService } from '@api'
import { createEffect } from 'effector'

import { handleError } from '@/utils/error'

export const applyPromoFx = createEffect(TrialPromoService.applyTrialPromo)

applyPromoFx.done.watch(({ result }) => {
  window.location.href = result
})

applyPromoFx.fail.watch(({ error }) => {
  handleError(error, 'Failed to apply promo token')
  setTimeout(() => {
    window.location.href = 'https://creatorhero.com'
  }, 3000)
})
